module.exports = __webpack_public_path__ + "static/media/dogs.61e01c18.png";